import { ButtonAddUser, DataTable } from './components';
import { HeaderPage } from '../components';

const PermissionsPage = () => (
  <div className='flex flex-col space-y-4 md:space-y-8 animate__animated animate__fadeIn'>
    <HeaderPage
      title='Permissions utilisateurs'
      description={`Gestion des accès utilisateurs à travers des permissions.`} />
    <div className='flex flex-col space-y-3'>
      <ButtonAddUser />
      <DataTable />
    </div>
  </div>
);

export default PermissionsPage;
